import { Component, Input, Output, EventEmitter } from '@angular/core';
import { modalOpen } from '@shared/animations/modal-open';
import { BtnType, Icon } from '@shared/enums';
import { ModalService } from './modal.service';

@Component({
  selector: 'sp-modal',
  template: `
    <div
      *ngIf="openModal$ | async"
      class="modal"
      [style.height]="height"
      [style.width]="width"
      [style.min-width]="minWidth"
      [@modalOpen]>
      <div class="button-container">
        <sp-button
          *ngIf="closable"
          [btn]="btn.IconOnly"
          [icon]="icon.Close"
          aria-label="Close"
          (onClick)="close()"></sp-button>
      </div>
      <div class="modal-container">
        <ng-content></ng-content>
      </div>
    </div>
    <div *ngIf="openModal$ | async" class="overlay" (click)="close()"></div>
  `,
  styleUrls: ['./modal.component.scss'],
  animations: [modalOpen],
})
export class ModalComponent {
  btn = BtnType;
  icon = Icon;
  @Input() height: string;
  @Input() width: string;
  @Input() minWidth: string;
  @Input() closable = true;
  openModal$ = this.modalService.isModalOpen$;

  @Output() visibleChange = new EventEmitter<boolean>();

  constructor(private modalService: ModalService) {}

  close() {
    this.modalService.setModalState(false);
  }
}
